/**
 * main.tsx starts the MSW worker only if both conditions are true. Read this
 * predicate rather than `VITE_USE_MSW` alone. A build that reads the flag alone
 * can treat itself as mocked while its requests reach the real network.
 *
 * `development` alone is not sufficient either. `npm run ui` also sets
 * development, and it points the app at the real services.
 */
export function mswActive(): boolean {
  return (
    import.meta.env.VITE_USE_MSW === "true" &&
    import.meta.env.VITE_ENVIRONMENT === "development"
  );
}
